import * as React from 'react';
import { Select, asField } from 'informedv1';

export const Dropdown = asField(({ fieldState, ...props }) => (
    <>
        <Select
            fieldState={fieldState}
            className="form-control"
            {...props}
            style={fieldState.error || fieldState.asyncError ? { border: 'solid 1px red' } : null}
        />
        {fieldState.error ? (
            <span style={{ color: 'red' }}>{fieldState.error}</span>
        ) : null}
        {fieldState.asyncError ? (
            <span style={{ color: 'red' }}>{fieldState.asyncError}</span>
        ) : null}
    </>
));
